import { render, staticRenderFns } from "./MultiplierBreakdownEntry.vue?vue&type=template&id=2d0f43a1&scoped=true"
import script from "./MultiplierBreakdownEntry.vue?vue&type=script&lang=js"
export * from "./MultiplierBreakdownEntry.vue?vue&type=script&lang=js"
import style0 from "./MultiplierBreakdownEntry.vue?vue&type=style&index=0&id=2d0f43a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0f43a1",
  null
  
)

export default component.exports